import React from "react";

/* -------------------------------------------------------------------------- */
/*  Renderer markdown condivisi per le news                                   */
/* -------------------------------------------------------------------------- */
/*
 * Perché questo file esiste:
 *
 * Il preflight di Tailwind azzera le liste con
 *     menu, ol, ul { list-style: none; margin: 0; padding: 0 }
 * quindi un `- voce` scritto nel CSV veniva convertito correttamente da
 * ReactMarkdown in <ul><li>, ma appariva come testo normale: niente pallino,
 * niente rientro. Il CSV era giusto, mancava lo stile.
 *
 * Qui ridiamo alle liste l'aspetto atteso, col marker nel rosa brand.
 */

// Link: gradiente brand, apertura in nuova tab, break-words per URL lunghi.
export const linkRenderer = ({ node, children, ...props }: any) => (
    <a
        {...props}
        target="_blank"
        rel="noopener noreferrer"
        className="underline underline-offset-2 hover:opacity-80 transition-opacity break-words"
        style={{
            background: "linear-gradient(90deg, #00858F 0%, #E6007E 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
            textDecorationColor: "#E6007E",
        }}
    >
        {children}
    </a>
);

// Liste puntate e numerate.
export const listRenderers = {
    ul: ({ node, ordered, ...props }: any) => (
        <ul
            {...props}
            className="list-disc pl-6 md:pl-8 my-4 space-y-2 marker:text-[#E6007E]"
        />
    ),
    ol: ({ node, ordered, ...props }: any) => (
        <ol
            {...props}
            className="list-decimal pl-6 md:pl-8 my-4 space-y-2 marker:text-[#E6007E] marker:font-bold"
        />
    ),
    li: ({ node, ordered, checked, ...props }: any) => (
        <li {...props} className="pl-1 leading-relaxed" />
    ),
};

/* Contesto "block": il <p> di markdown va bene, il contenitore è un <div>. */
export const blockComponents = {
    a: linkRenderer,
    ...listRenderers,
};

/* Contesto "inline" (dentro <h2>, <span>, caption): niente <p> annidato.
   Le liste restano disponibili, ma qui normalmente non servono. */
export const inlineComponents = {
    a: linkRenderer,
    ...listRenderers,
    p: ({ node, ...props }: any) => <>{props.children}</>,
};

/* Come inlineComponents, ma pensato per contenitori che POSSONO ospitare
   una lista (quindi <div>, non <p>): usato dall'intro delle news, dove il
   testo non deve essere spezzato in paragrafi ma le liste devono funzionare. */
export const introComponents = inlineComponents;
